<template>
<v-container fluid>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title>作業日報経費編集</v-card-title>
        <!-- 工事情報 -->
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-text-field label="作業日" v-model="constructionDate" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field label="工事名" v-model="tabData.constructionName" prepend-inner-icon="mdi-message-settings-variant-outline" dense outlined readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-select label="工種" v-model="tabData.constructionType" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.constructionTypeList" item-text="name" item-value="value" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
            <v-col cols="12" md="4" v-if="!workAreaDivision">
              <v-select label="作業項目" v-model="tabData.workItem" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.workItemList" item-text="name" item-value="value" :disabled="tabData.constructionType == null" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 入力フォーム -->
        <v-form ref="tab_form" v-model="tabValid" @submit.prevent>
          <v-container fluid>
            <div v-if="expenseDivision">
              <v-toolbar color="accent" dark flat dense><v-toolbar-title>経費区分</v-toolbar-title></v-toolbar>
              <div v-for="(data, name) in expenseDataTable" :key="name">
                <v-row class="mt-5">
                  <v-col cols="12">
                    <v-data-table :headers="headers" :items="data" :items-per-page="itemPerPage" hide-default-footer :key="renderingKeyCount">
                      <template slot="top">
                        <v-toolbar color="grey" dark flat dense>
                          <v-toolbar-title>{{ name }}</v-toolbar-title>
                          <v-spacer/>
                          <v-btn depressed color="success" @click="createItem(name)">新規作成</v-btn>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn class="mr-2" depressed color="primary" @click="editItem(item)">入力</v-btn>
                        <v-btn class="mr-2" depressed color="error" @click="deleteItem(item)">削除</v-btn>
                      </template>
                      <template v-slot:no-data>
                        データがありません。
                      </template>
                    </v-data-table>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-container>
        </v-form>
        <!-- アクション -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" :to="{ name: returnViewName, params: { worker_date: prmWorkerDate, user_id: prmUserId, construction_key: this.prmConstructionKey } }" :disabled="!returnViewName">戻る</v-btn>
          <v-btn depressed color="primary" @click.prevent="confirmationDialogDrawer=!confirmationDialogDrawer" :disabled="!tabValid">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

  <!-- 費目入力ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="expenseInputDialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline">費目入力</v-card-title>
        <v-card-text>
          <v-container>
            <v-select v-if="expenseItems.length > 0 && !editFlg" v-model="expenseItem" label="費目選択" :items="expenseItems" item-text="expense" @change="expenseChange" no-data-text="データがありません" dense outlined return-object/>
            <v-divider v-if="expenseItems.length > 0 && !editFlg" class="mb-5"/>
            <v-form ref="expense_input_form" v-model="expenseInputValid" @submit.prevent>
              <v-text-field v-model="expense" :rules="expenseNameRules" label="費目名" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="standard" :rules="standardNameRules" label="規格等" dense outlined></v-text-field>
              <v-text-field v-model="achievement" :rules="amountRules" label="数量" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field v-model="displayUnit" :rules="displayUnitRules" label="単位" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <!-- <v-text-field v-model="unitPrice" :rules="unitPriceRules" :label="price_updated" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field> -->
              <v-row no-gutters>
                <v-col cols="11">
                  <v-autocomplete label="取引先" v-model="supplier" :items="suppliers" item-text="name" item-value="value" hide-no-data hide-selected outlined dense return-object/>
                </v-col>
                <v-col cols="1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon class="mt-2 ml-3" color="success" @click.stop="supplierStoreDialogHandler" v-on="on">mdi-plus-circle</v-icon>
                    </template>
                    <span>取引先登録</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-text-field v-model="remarks" label="備考" :rules="remarksRules" dense outlined required></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" @click.stop="expenseInputCancelHandler">キャンセル</v-btn>
          <v-btn color="success" @click.stop="expenseInputSaveHandler" :disabled="!expenseInputValid">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 取引先登録ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="supplierStoreDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">取引先登録</v-card-title>
        <v-card-text>
          <v-form ref="suppliers_form" v-model="supplierValid" @submit.prevent>
            <v-text-field label="取引先名" v-model="supplierName" :rules="suppliersNameRules" dense outlined>
              <template v-slot:append>
                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
              </template>
            </v-text-field>
            <v-text-field label="備考" v-model="supplierRemarks" :rules="remarksRules" dense outlined></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="supplierStoreDialogCancelHandler">キャンセル</v-btn>
          <v-btn color="success" @click.prevent="supplierStore" :disabled="!supplierValid" depressed>登録</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 費目削除ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="expenseDeleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">費目削除</v-card-title>
        <v-card-text>
          <h4>{{ editedItem.expense }} を削除しますか？</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="expenseDeleteDialog = !expenseDeleteDialog">キャンセル</v-btn>
          <v-btn depressed color="error" @click.stop="expenseDeleteHandler">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業日報確認ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="confirmationDialogDrawer" persistent max-width="700px">
      <v-card>
        <v-card-title><span class="headline">作業日報確認</span></v-card-title>
        <v-card-text>
          <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ tabData.tabName }}</v-toolbar-title></v-toolbar>
          <v-row v-if="tabData.constructionType != null">
            <v-col cols="4"><header>工種</header></v-col>
            <v-col cols="8"><header>{{ tabData.constructionType.name }}</header></v-col>
          </v-row>
          <v-divider/>
          <v-row v-if="(tabData.workItem != null) && !workAreaDivision">
            <v-col cols="4"><header>作業項目</header></v-col>
            <v-col cols="8"><header>{{ tabData.workItem.name }}</header></v-col>
          </v-row>
          <v-divider/>
          <!-- 経費区分 -->
          <v-row>
            <v-col cols="12">
              <div v-for="(data, name) in tabData.expenseTableData" :key="name">
                <v-data-table v-if="data.length > 0" :headers="comformHeaders" :items="data" :items-per-page="itemPerPage" hide-default-footer>
                  <template slot="top">
                    <v-toolbar color="grey" dark flat dense>
                      <v-toolbar-title>{{ name }}</v-toolbar-title>
                    </v-toolbar>
                  </template>
                </v-data-table>
                <v-divider v-if="data.length > 0"/>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" @click="confirmationDialogDrawer=!confirmationDialogDrawer">キャンセル</v-btn>
          <v-btn color="success" @click.prevent="submit()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

    <!-- 費目登録時警告ダイアログ -->
    <v-row justify="center">
      <v-dialog v-model="expenseAlertDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span><v-icon large class="mr-2" color="red">mdi-alert-octagon</v-icon>実行できません</span>
          </v-card-title>
          <v-card-text>
            選択された費目は既に登録されています。
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="expenseAlertDialog=!expenseAlertDialog">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import Rule from "@/validation/rules";
import SuppliersApi from "@/api/suppliers-api";
import WorkerDailyReportSubApi from "@/api/worker-daily-report-sub-api";
import WorkerDailyReportExpenseBulkApi from "@/api/worker-daily-report-expense-bulk-api";
export default {
  name: "WorkerDailyReportExpenseEdit",
  // props: ["user"],
  data: () => ({
    loading: false,
    returnViewName: "",
    // 画面引数
    prmRecordId: 0,
    prmUserId: null,
    prmWorkerDate: "",
    prmReferrer: "",
    prmConstructionKey: null,
    // ------------------------
    // 共通
    // ------------------------
    renderingKeyCount: 0,
    // 作業日
    constructionDate: "",
    // 作業項目可否
    workAreaDivision: false,
    // 格納用
    tabData: {
      tabName: null,
      constructionId: null,
      constructionNumber: null,
      constructionName: null,
      siteName: null,
      constructionTypeList: null,
      constructionType: null,
      workArea: false,
      workItemList: null,
      workItem: null,
      startWorkerTime: null,
      endWorkerTime: null,
      workerBreakHourTime: null,
      workerBreakMinuteTime: null,
      startOverTime: null,
      endOverTime: null,
      overBreakHourTime: null,
      overBreakMinuteTime: null,
      workerContent: "",
      businessTrip: "",
      stay: false,
      move: 0,
      etc: false,
      remark: null,
      priceUpdated: "",
      expenseTableDataList: null,
      expenseTableData: null,
      expenseSelectBoxList: null,
      expenseSelectBox: null,
      workerTime: null,
      overTime: null
    },
    // バリデート
    tabValid: false,
    // データ表示数
    itemPerPage: 300,

    // ------------------------
    // 経費区分
    // ------------------------
    expenseDivisionData: [],
    expenseDivision: false,
    expenseDataTable: null,
    expenseSelectBox: null,
    headers: [
      { text: "費目名", value: "expense", sortable: false },
      { text: "規格等", value: "standard", sortable: false },
      { text: "実績 / 予算", value: "displayAchievement", sortable: false },
      { text: "単位", value: "displayUnit", sortable: false },
      // { text: "単価", value: "unitPrice" },
      { text: "取引先", value: "supplierName", sortable: false },
      { text: "アクション", value: "action", sortable: false }
    ],
    editedItem: {},
    expenseId: "",
    expense: "",
    standard: "",
    amount: "",
    achievement: "",
    displayUnit: "",
    unitPrice: "",
    remarks: "",
    priceUpdated: "",
    before_price: null,
    price_updated: "単価",
    suppliers: [],
    supplier: null,
    expenseItems: [],
    expenseItem: null,

    // ------------------------
    // 費目入力ダイアログ
    // ------------------------
    expenseInputDialog: false,
    expenseInputValid: false,
    editFlg: false,
    expenseChangeFlg: false,
    expenseNameRules: Rule.expenseNameRules,
    standardNameRules: Rule.standardNameRules,
    amountRules: Rule.amountRules,
    displayUnitRules: Rule.displayUnitRules,
    unitPriceRules: Rule.unitPriceRules,
    remarksRules: Rule.remarksRules,

    // ------------------------
    // 取引先登録ダイアログ
    // ------------------------
    supplierStoreDialog: false,
    supplierName: "",
    supplierRemarks: "",
    supplierValid: false,
    suppliersNameRules: Rule.suppliersNameRules,

    // ------------------------
    // 費目削除ダイアログ
    // ------------------------
    expenseDeleteDialog: false,

    // ------------------------
    // 作業報告確認ダイアログ
    // ------------------------
    confirmationDialogDrawer: false,
    confirmationSelectTab: null,
    comformHeaders: [
      { text: "費目名", value: "expense" },
      { text: "規格等", value: "standard" },
      { text: "実績 / 予算", value: "displayAchievement" },
      { text: "単位", value: "displayUnit" },
      // { text: "単価", value: "unitPrice" },
      { text: "取引先", value: "supplierName" }
    ],

    // ------------------------
    // 費目登録時警告ダイアログ
    // ------------------------
      expenseAlertDialog: false,
  }),
  created() {
    this.initialize();
  },
  watch: {
    tabValid() {
      this.tabValid = true
      for(var input of this.$refs.tab_form.inputs) {
        if (!input.valid) {
          this.tabValid = false
          break;
        }
      }
    },
    achievement(value) {
      this.achievement = this.stringFormat(value);
    },
    unitPrice(value) {
      if (this.before_price != null && this.before_price != value) {
        this.priceUpdated = this.getNowYMD();
        this.price_updated = "単価 (更新日時: " + this.priceUpdated + ")";
      }
      this.unitPrice = this.stringFormat(value);
    }
  },
  methods: {
    // ------------------------
    // 初期化処理
    // ------------------------
    initialize() {
      this.isLoading();
      // 画面引数をセット
      this.prmRecordId = this.$route.params.id;
      this.prmUserId = this.$route.params.user_id;
      this.prmWorkerDate = this.$route.params.worker_date;
      this.prmReferrer = this.$route.params.referrer;
      this.prmConstructionKey = this.$route.params.construction_key;
      this.constructionDate = this.prmWorkerDate;
      // 遷移元画面に応じたパンくずリストの設定
      let breadcrumbs = [];
      if (this.prmReferrer == 'store') {
        // 作業日報作成画面から遷移
        this.returnViewName = 'WorkerDailyReportStore';
        const toView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId
          }
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
          { text: "作業日報作成", disabled: false, href: null, to: toView },
          { text: "作業日報経費編集", disabled: true }
        ];
      }
      if (this.prmReferrer == 'edit') {
        // 作業日報編集画面から遷移
        this.returnViewName = 'WorkerDailyReportEdit';
        const toEditView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId,
            construction_key: this.prmConstructionKey
          }
        };
        if (!this.prmConstructionKey) {
          breadcrumbs = [
            { text: "ダッシュボード", disabled: false, href: "/dashboard" },
            { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
            { text: "作業日報編集", disabled: false, href: null, to: toEditView },
            { text: "作業日報経費編集", disabled: true }
          ];
        } else {
          // 工事日報画面経由の作業日報編集画面から遷移
          const toConstructionView = {
            name: "ConstructionDailyReportEdit",
            params: this.prmConstructionKey
          };
          breadcrumbs = [
            { text: "ダッシュボード", disabled: false, href: "/dashboard" },
            { text: "工事日報一覧", disabled: false, href: "/report/daily/construction" },
            { text: "工事日報再集計", disabled: false, href: null, to: toConstructionView },
            { text: "作業日報編集", disabled: false, href: null, to: toEditView },
            { text: "作業日報経費編集", disabled: true }
          ];
        }
      }
      if (breadcrumbs) {
        this.$route.meta.breadcrumbs = breadcrumbs;
        this.$emit('updatebc');
      }
      // 作業日報を取得
      this.suppliersApi = new SuppliersApi();
      this.WorkerDailyReportSubApi = new WorkerDailyReportSubApi();
      this.workerDailyReportExpenseBulkApi = new WorkerDailyReportExpenseBulkApi();
      const promise = this.workerDailyReportExpenseBulkApi.info(this.prmRecordId);
      promise.then((response) => {
        // 日報情報をセット
        this.tabData = response.data.body.worker_daily_report_info.report;
        // 取引先情報
        const suppliers_list = response.data.body.suppliers_list;
        for (let item of suppliers_list) {
          this.suppliers.push({
            name: item.name,
            value: item.id
          });
        }
        // 集計費目情報
        const aggregate_list = response.data.body.aggregate_list;
        for (let agregateName in aggregate_list) {
          const agregate = response.data.body.aggregate_list[agregateName];
          this.expenseDivisionData[agregateName] = agregate;
        }
        // 経費情報をセット
        this.expenseDivision = false;
        if (this.tabData.constructionType != null) {
          const constructionTypeIndex = this.tabData.constructionType.value;
          this.tabData.expenseTableData = this.tabData.expenseTableDataList[constructionTypeIndex];
          for (let data of this.expenseDivisionData) {
            if (!(data.name in this.tabData.expenseTableData)) {
              this.tabData.expenseTableData[data.name] = [];
            }
          }
          this.expenseDataTable = this.tabData.expenseTableData;
          this.tabData.expenseSelectBox = this.tabData.expenseSelectBoxList[constructionTypeIndex];
          this.expenseSelectBox = this.tabData.expenseSelectBox;
          this.expenseDivision = true;
        }
        this.workAreaDivision = this.tabData.workArea;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: this.returnViewName, params: { worker_date: this.prmWorkerDate, user_id: this.prmUserId, construction_key: this.prmConstructionKey } });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // ------------------------
    // 経費区分
    // ------------------------
    //
    createItem(name) {
      if (this.$refs.expense_input_form != null) {
        this.$refs.expense_input_form.resetValidation();
      }
      var aggregate = this.expenseDivisionData.find((item) => { return (item.name === name); });
      var aggregateName = name;
      if ((name in this.expenseSelectBox) && this.expenseSelectBox[name].length > 0) {
        this.expenseItems = this.expenseSelectBox[name];
      } else {
        this.expenseItems = [];
      }
      this.editedItem = {
        id: "",
        supplier: null,
        supplierName: "",
        aggregate: aggregate,
        aggregateName: aggregateName,
        amount: "",
        displayUnit: "",
        expense: "",
        multiple: 0,
        no: 0,
        percentage: 1,
        price: 0,
        standard: "",
        tax: 0.1,
        taxName: "10%",
        unitPrice: 0,
        achievement: 0,
        displayAchievement: "",
        remarks: "",
        priceUpdated: this.getNowYMD()
      };
      this.price_updated = "単価";
      this.editFlg = false;
      this.expenseChangeFlg = false;
      this.expenseInputDialog = true;
    },
    //
    editItem(item) {
      this.editedItem = item;
      this.expense = this.editedItem.expense;
      this.standard = this.editedItem.standard;
      this.amount = this.editedItem.amount;
      this.achievement = this.editedItem.achievement;
      this.displayUnit = this.editedItem.displayUnit;
      this.unitPrice = this.editedItem.unitPrice;
      this.supplier = this.editedItem.supplier;
      this.remarks = this.editedItem.remarks;
      this.before_price = this.editedItem.unitPrice;
      this.priceUpdated = "priceUpdated" in this.editedItem ? this.editedItem.priceUpdated : this.getNowYMD();
      this.price_updated = "単価 (更新日時: " + this.priceUpdated + ")";
      this.editFlg = true;
      this.expenseInputDialog = true;
    },
    //
    deleteItem(item) {
      this.editedItem = item;
      this.expenseDeleteDialog = true;
    },
    //
    expenseChange() {
      if (this.expenseItem.id) {
        this.expenseId = this.expenseItem.id;
      }
      this.expense = this.expenseItem.expense;
      this.standard = this.expenseItem.standard;
      this.amount = this.expenseItem.amount;
      this.achievement = this.expenseItem.amount;
      this.displayUnit = this.expenseItem.displayUnit;
      this.unitPrice = this.expenseItem.unitPrice;
      this.before_price = this.expenseItem.unitPrice;
      this.priceUpdated = "priceUpdated" in this.expenseItem ? this.expenseItem.priceUpdated : this.getNowYMD();
      this.price_updated = "単価 (更新日時: " + this.priceUpdated + ")";
      this.expenseChangeFlg = true;
    },
    // ------------------------
    // 費目入力ダイアログ
    // ------------------------
    //
    expenseInputSaveHandler() {
      var checkflg = false;
      this.editedItem.id = this.expenseId;
      this.editedItem.expense = this.expense;
      this.editedItem.standard = this.standard;
      this.editedItem.amount = this.amount;
      this.editedItem.achievement = this.achievement;
      this.editedItem.displayUnit = this.displayUnit;
      this.editedItem.unitPrice = this.unitPrice;
      this.editedItem.price = this.achievement * this.unitPrice;
      this.editedItem.supplier = this.supplier;
      this.editedItem.supplierName = this.supplier ? this.supplier.name : "";
      this.editedItem.displayAchievement = this.amount ? this.achievement + " / " + this.amount : this.achievement + " / -";
      this.editedItem.remarks = this.remarks;
      if (this.priceUpdated) {
        this.editedItem.priceUpdated = this.priceUpdated;
      }
      if(!this.editFlg){
        if(this.editedItem.id == ""){
          this.editedItem.id = new Date().getTime().toString() + Math.floor(Math.random() * 10).toString();
        }
        // for(var expenseitem of this.tabData.expenseTableData[this.editedItem.aggregateName]){
        //   if(expenseitem.id == this.editedItem.id){
        //     checkflg = true;
        //   }
        // }
      }
      if (checkflg) {
        this.expenseAlertDialog = true;
        this.expenseItem = null;
        this.expenseId = "";
        this.expense = "";
        this.standard = "";
        this.amount = "";
        this.achievement = "";
        this.displayUnit = "";
        this.unitPrice = "";
        this.supplier = null;
        this.remarks = "";
        this.before_price = null;
        this.priceUpdated = "";
        this.renderingKeyCount += 1;
        this.createItem(this.editedItem.aggregateName);
      }else{
        const index =  this.tabData.expenseTableData[this.editedItem.aggregateName].indexOf(this.editedItem);
        if(index > -1) {
          this.tabData.expenseTableData[this.editedItem.aggregateName][index] = this.editedItem
        } else {
          this.tabData.expenseTableData[this.editedItem.aggregateName].push(this.editedItem);
        }
        this.expenseInputCancelHandler();
      }
    },
    //
    expenseInputCancelHandler () {
      this.expenseItem = null;
      this.expenseId = "";
      this.expense = "";
      this.standard = "";
      this.amount = "";
      this.achievement = "";
      this.displayUnit = "";
      this.unitPrice = "";
      this.supplier = null;
      this.remarks = "";
      this.before_price = null;
      this.priceUpdated = "";
      this.expenseInputDialog = false;
      this.renderingKeyCount += 1;
      this.expenseChangeFlg = false;
    },
    // ------------------------
    // 取引先登録ダイアログ
    // ------------------------
    //
    supplierStoreDialogCancelHandler() {
      this.supplierStoreDialog = false;
      this.supplierName = "";
      this.supplierRemarks = "";
    },
    //
    supplierStoreDialogHandler() {
      this.supplierStoreDialog = true;
      if (this.$refs.suppliers_form) {
        this.$refs.suppliers_form.resetValidation();
      }
    },
    //
    supplierStore() {
      if (this.$refs.suppliers_form.validate()) {
        this.isLoading();
        const params = {
          name: this.supplierName,
          remarks: this.supplierRemarks,
        };
        const promiseStore = this.suppliersApi.store(params);
        promiseStore.then((response) => {
            this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.supplierStoreDialog = false;
          const promiseList = this.suppliersApi.list();
          promiseList.then((response) => {
            this.suppliers = [];
            for (var sup of response.data.body.suppliers_list) {
              this.suppliers.push({
                name: sup.name,
                value: sup.id
              });
            }
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
              if (error.response.data.status == statusList.status.authError) {
                this.$emit('logoutConform');
              } else if (error.response.data.status == statusList.status.entityError) {
                this.$emit("error", error.response.data.message);
                this.$router.push({ name: "Dashboard" })
              } else {
                this.$emit("error", error.response.data.message);
              }
            } else {
              this.$emit("error", "サーバーエラーが発生しました。");
            }
          }).finally(() => {
            this.supplierName = "";
            this.supplierRemarks = "";
            this.isLoading();
          });
        });
      }
    },
    // ------------------------
    // 費目削除ダイアログ
    // ------------------------
    expenseDeleteHandler() {
      const index = this.tabData.expenseTableData[this.editedItem.aggregateName].indexOf(this.editedItem);
      this.tabData.expenseTableData[this.editedItem.aggregateName].splice(index,1)
      this.expenseDeleteDialog = false;
    },
    // ------------------------
    // 作業報告確認ダイアログ
    // ------------------------
    submit() {
      this.isLoading();
      const params = {
        report: JSON.stringify(this.tabData)
      };
      const promise = this.WorkerDailyReportSubApi.update(this.prmRecordId, { params: params });
      promise.then((response) => {
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.$router.push({ name: this.returnViewName, params: { worker_date: this.prmWorkerDate, user_id: this.prmUserId, construction_key: this.prmConstructionKey } });
      });
    },
    // ------------------------
    // その他処理
    // ------------------------
    // ローディング表示・非表示
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    // 数字文字の全角⇒半角変換
    stringFormat(value) {
      var result = value.toString()
      while (result.match(/[０-９]/g)) {
        result = result.replace(/[０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
      }
      return result;
    },
    // 現在日付取得（yyyy/mm/dd形式）
    getNowYMD() {
      var dt = new Date();
      var y = dt.getFullYear();
      var m = ("00" + (dt.getMonth()+1)).slice(-2);
      var d = ("00" + dt.getDate()).slice(-2);
      var result = y + "/" + m + "/" + d;
      return result;
    },
    // 日付フォーマット（yyyy/mm/dd⇒yyyy-mm-dd形式）
    parseDate(date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  }
}
</script>
